import { useRef, useState } from "react"
import { Box, Button, Menu, Portal, Stack } from "@mui/material"
import { sortModes } from "routes/schedule/my-schedules/my-custom-schedules/lib/sort-modes"
import Iconify from "minimals-template/components/Iconify"
import { Repeat } from "lib/@components/repeat"
import { MyScheduleSortOption } from "./my-schedule-sort-option"

export function MyScheduleSort({ value, onChange }) {
    const [anchor, setAnchor] = useState(null)
    const ref = useRef()
    return (
        <>
            <Stack
                className="my-schedule-sort"
                data-cy="my-schedule-sort"
                onClick={open}
                sx={{ cursor: "pointer", fontSize: "85%", color: "text.primary" }}
                component={Button}
                role="menu"
                direction="row"
                alignItems="center"
                spacing={1}
            >
                <Box sx={{ fontWeight: "bold" }}>Sort:</Box>
                <Box sx={{ fontWeight: "normal" }} ref={ref}>
                    {sortModes[value]}
                </Box>
                <Box sx={{ fontSize: 24, lineHeight: 0 }}>
                    <Iconify icon="mdi:arrow-down-drop" />
                </Box>
            </Stack>
            <Portal>
                <Menu sx={{ zIndex: 3000 }} onClose={close} open={Boolean(anchor)} anchorEl={anchor}>
                    <Repeat
                        list={Object.entries(sortModes)}
                        item={<MyScheduleSortOption value={value} onChange={onChange} />}
                        keyFn={([mode]) => mode}
                    />
                </Menu>
            </Portal>
        </>
    )

    function open() {
        setAnchor(ref.current)
    }

    function close() {
        setAnchor(null)
    }
}
